import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    width: 500,
    backgroundColor: 'transparent',
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid var(--primary-color)',
    borderRadius: '8px',
    padding: 'unset',
    fontSize: '13px',
  },
  '.position-relative:not(:last-child)': {
    borderBottom: '1px solid var(--primary-color)',
  },

  '.position-relative:first-of-type': {
    borderRadius: '8px 8px 0 0',
  },

  '.position-relative:last-child': {
    borderRadius: '0 0 8px 8px',
  },
});
